import { z } from "zod";
import { cpfSchema, trimmed } from "./common";

export const clientInputSchema = z.object({
  name: trimmed(120),
  phone: z.string().trim().min(8, "Telefone incompleto").max(30),
  email: z.union([z.literal(""), z.string().trim().toLowerCase().pipe(z.email().max(200))]).default(""),
  cpf: z.union([z.literal(""), cpfSchema]).default(""),
});
export type ClientInput = z.infer<typeof clientInputSchema>;

export const clientNoteInputSchema = z.object({ text: trimmed(500) });
export type ClientNoteInput = z.infer<typeof clientNoteInputSchema>;

export interface Client {
  id: string;
  name: string;
  phone: string;
  email: string;
  cpf: string;
  createdAt: string;
}

export interface ClientNote {
  id: string;
  text: string;
  authorName: string;
  createdAt: string;
}
